import { render, staticRenderFns } from "./RipaInvalidUserDialog.vue?vue&type=template&id=876f5df2"
import script from "./RipaInvalidUserDialog.vue?vue&type=script&lang=js"
export * from "./RipaInvalidUserDialog.vue?vue&type=script&lang=js"
import style0 from "./RipaInvalidUserDialog.vue?vue&type=style&index=0&id=876f5df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports